import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select, {components} from "react-select";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import * as Yup from "yup";
import { Listbox } from "@headlessui/react";
import { sanitizeInput } from "../../../utils";
import InputField from "../../../component/input-field";
import {
  Menu,
  MenuHeader,
  MenuItem,
  SubMenu,
} from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/zoom.css";

const schema = Yup.object().shape({
  configuration_setting_mapping_id: Yup.string(),
  activity_id: Yup.object().shape({
    label: Yup.string().required("This is required."),
    value: Yup.string().required("This is required."),
  }),
  activity_customfields_id: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }),
  sequence: Yup.number().required("This field is required."),
  is_mandatory: Yup.boolean().required("This field is required."),
  duration: Yup.number(),
  duration_type: Yup.string(),
  loop_activity: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }).nullable(),
  link_activity: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }).nullable(),
  dependent_todo: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }).nullable(),
  dependent_todo_custom_field_id: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }).nullable(),
  dependent_todo_custom_field_value: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }).nullable(),
  department_id: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }),
  user_id: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
  }),
  collaborator_id: Yup.object().shape({
    label: Yup.string(),
    value: Yup.string(),
    type: Yup.string()
  }),
});

const TodoConfig = ({
  data,
  activeTodo,
  setActiveModal,
  todoList,
  workflowFormik,
  is_copy,
  deptWithUser,
}) => {
  const { allActivityList } = useSelector((state) => state.assignmentReducer);
  const { deptWithUserAndCollaborators } = useSelector(state => state.department)
  const [linkComponentList, setLinkComponentList] = useState([]);
  const [dependentComponentList, setDependentComponentList] = useState([]);
  const [dependentComponentWithValues, setDependentComponentWithValues] =
    useState([]);
  const [dependentValuesList, setDependentValuesList] = useState([]);
  const [isMasterTodo, setIsMasterTodo] = useState(false);
  const [linkAndLoopTodosList, setLinkAndLoopTodoList] = useState([]);
  const [dependentTodoList, setDependentTodoList] = useState([]);
  const [isMultiSelect, setIsMultiSelect] = useState(true);

  const defaultValues = {
    configuration_setting_mapping_id:
      data?.configuration_setting_mapping_id && !is_copy
        ? data.configuration_setting_mapping_id
        : "",
    activity_id: data?.activity_id ? data.activity_id : "",
    activity_customfields_id: "",
    sequence: data?.sequence
      ? data.sequence
      : (workflowFormik.values.workflow_todos?.length + 1) || 1,
    is_mandatory: data?.is_mandatory ? data.is_mandatory : false,
    duration: data?.duration ? data.duration_type === "days" ? data.duration/24 : data.duration : 0,
    loop_activity: data?.loop_activity
      ? todoList.find((item) => item.value === data.loop_activity) || ""
      : "",
    link_activity: data?.link_activity
      ? todoList.find((item) => item.value === data.link_activity) || ""
      : "",
    dependent_todo: data?.dependent_todo
      ? todoList.find((item) => item.value === data.dependent_todo) || ""
      : "",
    dependent_todo_custom_field_value: "",
    dependent_todo_custom_field_id: "",
    duration_type: data?.duration_type ? data.duration_type : "hours",
    department_id: data?.department_id ? deptWithUserAndCollaborators?.departments.find(item => item.value === data.department_id) : "",
    user_id: data?.department_id ? deptWithUserAndCollaborators?.departments.find(item => item.value === data.department_id)?.user_departments.find(item => item.value === data.user_id) : "",
    collaborator_id: data?.collaborator_id ? deptWithUserAndCollaborators?.collaborators.find(item => item.value === data.collaborator_id) : "",
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: defaultValues,
    validationSchema: schema,
    onSubmit: (data) => {
      handleSubmit(data);
    },
  });

  const filterLinkComponents = (link_activity) => {
    let linkComponents = [];
    let linkValue = []
    if (allActivityList?.length > 0 && link_activity) {
      const customComponents = allActivityList.find(
        (item) => item.id === link_activity
      );
      if (customComponents) {
        linkValue = linkComponents = customComponents?.activitycustomfields
          ?.filter((item) => item?.todo_component?.type === "date/time")

        linkComponents = customComponents?.activitycustomfields
          ?.filter((item) => item?.todo_component?.type === "date/time")
          .map((item) => ({
            label: item?.todo_component.label,
            value: item.id,
          }));
      }
    }
    setLinkComponentList(linkComponents);
    return linkValue;
  };

  const filterDependentTodoCompnents = (dependent_todo) => {
    let dependentComponents = [];
    let dependentValue = [];
    if (allActivityList?.length > 0 && dependent_todo) {
      const customComponents = allActivityList.find(
        (item) => item.id === dependent_todo
      );
      if (customComponents) {
        dependentValue = customComponents?.activitycustomfields?.filter(
          (item) => ["dropdown", "radio group", "check box", "toggle"].includes(item.todo_component?.type)
        );
        dependentComponents = customComponents?.activitycustomfields
          ?.filter((item) =>
            ["dropdown", "radio group", "check box", "toggle"].includes(item.todo_component?.type)
          )
          .map((item) => ({
            label: item?.todo_component.label,
            value: item.id,
          }));
      }
    }
    setDependentComponentList(dependentComponents);
    setDependentComponentWithValues(dependentValue);
    return dependentValue;
  };

  useEffect(() => {
    if (allActivityList?.length > 0 && data.link_activity) {
      const linkComponents = filterLinkComponents(data.link_activity);
      if (data?.activity_customfields_id) {
        let linkField = linkComponents.find(
          (item) => item.id === data?.activity_customfields_id
        );
        if (linkField && linkField?.todo_component) {
          linkField = {
            label: linkField?.todo_component.label,
            value: linkField.id,
          };
          formik.setFieldValue("activity_customfields_id", linkField);
        }
      }else{
        formik.setFieldValue("activity_customfields_id", { label: "Performance Date", value: "Performance Date" });
      }
    }

    if (allActivityList?.length > 0 && data.dependent_todo) {
      const dependentComponents = filterDependentTodoCompnents(
        data.dependent_todo
      );
      if (data?.dependent_todo_custom_field_id) {
        let dependentField = dependentComponents.find(
          (item) => item.id === data?.dependent_todo_custom_field_id
        );
        if (dependentField && dependentField?.todo_component) {
          formik.setFieldValue(
            "dependent_todo_custom_field_id",
            {
              label: dependentField?.todo_component.label,
              value: dependentField.id,
            }
          );

          const parseValues = JSON.parse(data.dependent_todo_custom_field_value || '[]')

          if (dependentField && ["check box", "toggle"].includes(dependentField?.todo_component?.type)) {
            setIsMultiSelect(false);
            let options = [
              {
                label: "True",
                value: "true"
              },
              {
                label: "False",
                value: "false"
              }
            ]
            const values = options.find(item => parseValues.includes(item.value));
            if(values) formik.setFieldValue("dependent_todo_custom_field_value", values);;
            setDependentValuesList(options);
          }else if (dependentField){            
            let values = JSON.parse(
              dependentField?.todo_component?.list_values || "[]"
            );
            values = values.map((item) => ({ label: item, value: item }));
            const dependentValue = values.filter(item => parseValues.includes(item.value));
            if(dependentValue?.length > 0)  formik.setFieldValue("dependent_todo_custom_field_value", dependentValue);
            setIsMultiSelect(true);
            setDependentValuesList(values);
          }
        }
      }
    }

    if (allActivityList?.length > 0 && data.activity_id) {
      const todo = allActivityList.find((item) => item.id === data.activity_id);

      if (todo) {
        if (todo && todo?.master_activity_id && todo?.is_trackable === "1") {
          setIsMasterTodo(true);
        }
      }
    }

    return () => {
      setLinkComponentList([]);
      setDependentComponentList([]);
      setDependentComponentWithValues([]);
      setDependentValuesList([]);
      setIsMasterTodo(false);
      setIsMultiSelect(true);
    }
  }, [allActivityList, data, activeTodo]);

  useEffect(() => {
    const list = workflowFormik.values.workflow_todos?.slice(0, activeTodo).map((item) => item.activity_id) || [];
    setLinkAndLoopTodoList(list);
    return () => {
      setLinkAndLoopTodoList([]);
    }
  }, [workflowFormik])

  useEffect(() => {
    if(Object.keys(deptWithUserAndCollaborators).length > 0){
      if(data.department_id){
        const dept = deptWithUserAndCollaborators.departments?.find(item => item.value === data.department_id);
        if(dept){
          formik.setFieldValue("department_id", { label: dept.label, value: dept.value });
          if(data.user_id && dept.user_departments?.length > 0){
            const user = dept.user_departments.find(item => item.value === data.user_id);
            if(user){
              formik.setFieldValue("user_id", user);
            }
          }
        }
      }

      if(data.collaborator_id){
        const collaborator = deptWithUserAndCollaborators.collaborators?.find(item => item.value === data.collaborator_id);
        if(collaborator){
          formik.setFieldValue("collaborator_id", collaborator)
        }
      }
    }
  }, [data, deptWithUserAndCollaborators])

  useEffect(() => {
    if (!activeTodo) {
      formik.resetForm();
    }
  }, [activeTodo]);

  const handleSubmit = (payload) => {
    if (
      payload.dependent_todo &&
      (!payload?.dependent_todo_custom_field_id ||
        !payload?.dependent_todo_custom_field_value)
    ) {
      swal({
        content: (
          <CustomeModal
            type="warning"
            title="Warning!"
            content={`"Component" and "Value For Activation" is required for dependent todo.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
      return;
    }

    if (
      !payload.department_id && !payload.collaborator_id
    ) {
      swal({
        content: (
          <CustomeModal
            type="warning"
            title="Warning!"
            content={`"Department" and "Collaborator/Customer" is required.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
      return;
    }

    let todoData = {
      activity_id: payload.activity_id,
      link_activity: payload.link_activity ? payload.link_activity.value : null,
      activity_customfields_id: payload?.activity_customfields_id
        ? payload.activity_customfields_id?.value !== "Performance Date" ? payload.activity_customfields_id?.value : null
        : null,
      loop_activity: payload.loop_activity ? payload.loop_activity.value : null,
      sequence: payload.sequence,
      is_mandatory: payload.is_mandatory,
      duration:
        payload.duration > 0
          ? payload.duration_type === "hours"
            ? payload.duration
            : payload.duration * 24
          : 0,
      dependent_todo: payload?.dependent_todo
        ? payload.dependent_todo.value
        : null,
      dependent_todo_custom_field_id: payload?.dependent_todo_custom_field_id
        ? payload.dependent_todo_custom_field_id.value
        : null,
      collaborator_id: payload?.collaborator_id
        ? payload?.collaborator_id.value
        : null,
      department_id: payload?.department_id
        ? payload?.department_id.value
        : null,
      user_id: payload?.user_id ? payload?.user_id.value : null,
    };

    if(payload?.dependent_todo_custom_field_value){
      if(Array.isArray(payload?.dependent_todo_custom_field_value)){
        todoData['dependent_todo_custom_field_value'] = payload.dependent_todo_custom_field_value.map(item => item.value)
      }else{
        todoData['dependent_todo_custom_field_value'] = [payload.dependent_todo_custom_field_value.value]
      }
    }

    if (payload.configuration_setting_mapping_id)
      todoData["configuration_setting_mapping_id"] =
        payload.configuration_setting_mapping_id;

    if(todoData['dependent_todo_custom_field_value']?.length > 0) todoData['dependent_todo_custom_field_value'] = JSON.stringify(todoData['dependent_todo_custom_field_value']);

    workflowFormik.setFieldValue(`workflow_todos[${activeTodo}]`, todoData);
    formik.resetForm();
    setActiveModal(false);
  };

  const getInitials = ({user_id, collaborator_id, department_id}) => {
    const value = user_id ? user_id.label : collaborator_id ? collaborator_id.label : department_id ? department_id.label : "Select User";
    return value.match(/\b\w/g).join("").toUpperCase();
  }

  const getDependentTodoList = () => {
    let availableTodos = [];

    for(const todo of linkAndLoopTodosList){
      const customComponents = allActivityList.find(
        (item) => item.id === todo.value
      );
      if (customComponents) {
        const dependentValue = customComponents?.activitycustomfields?.filter(
          (item) => ["dropdown", "radio group", "check box", "toggle"].includes(item.todo_component?.type)
        );
        if(dependentValue?.length > 0){
          availableTodos.push(todo)
        }
      }
    }
    return availableTodos;
  }

  useEffect(() => {
    const list = getDependentTodoList();
    setDependentTodoList(list);
  }, [linkAndLoopTodosList]);


  const MoreSelectedBadge = ({ items }) => {
    const style = {
      marginLeft: "auto",
      fontFamily: "inter",
      fontSize: "14px",
      padding: "3px",
      fontWeight: 600,
    };

    const title = items.join(", ");
    const length = items.length;
    const label = `+${length}`;

    return (
      <div style={style} title={title}>
        {label}
      </div>
    );
  };

  const MultiValue = ({ index, getValue, ...props }) => {
    const maxToShow = 1;
    const overflow = getValue()
      .slice(maxToShow)
      .map((x) => x.label);

    return index < maxToShow ? (
      <components.MultiValue {...props} />
    ) : index === maxToShow ? (
      <MoreSelectedBadge items={overflow} />
    ) : null;
  };

  

  return (
    <div className="py-6 space-y-4">
      {/* First Row */}
      <div className="grid grid-cols-3 gap-3">
        <div className="p-3 rounded-md bg-[--bg-color-50] border border-[#E1E3E5] flex flex-col space-y-3">
          <p className="font-inter font-bold text-sm text-[#535860]">To Do</p>
          <p className="font-inter font-normal text-[13px] text-[#535860]">
            This to do is added to the workflow.
          </p>
          <Select
            options={todoList.filter((ele) => {
              return !workflowFormik.values.workflow_todos.some(
                (item) => item.activity_id?.value === ele.value
              );
            })}
            isClearable={true}
            menuPortalTarget={document.body}
            className="basic-single text-sm unresetText"
            classNames={{
              control: (style) => {
                return `!border !shadow-sm ${
                  style.isFocused
                    ? "!border-[--bg-color-300]/50"
                    : "!border-slate-200 hover:!border-gray-300"
                }`;
              },
              container: (style) => {
                return "!h-[37.5px] !font-inter !text-sm";
              },
              menuList: (style) => {
                return `!max-h-[200px]`;
              },
            }}
            name="activity_id"
            value={formik.values.activity_id}
            onChange={(todo) => {
              formik.setFieldValue("activity_id", todo);
              if (todo) {
                const findItem = allActivityList.find(
                  (item) => item.id === todo.value
                );
                if (
                  findItem &&
                  findItem?.master_activity_id &&
                  findItem?.is_trackable === "1"
                ) {
                  setIsMasterTodo(true);
                }
              }
            }}
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              placeholder: (provided, state) => ({
                ...provided,
                color: "#9B9B9B",
                fontSize: "14px",
              }),
            }}
            placeholder="Select Todo"
            menuPlacement="auto"
          />
          {Boolean(
            formik.touched.activity_id && formik.errors.activity_id?.value
          ) ? (
            <p className="text-xs text-rose-500 text-left">
              {`${formik.errors.activity_id.value}!`}
            </p>
          ) : null}
        </div>
        <div className="p-3 rounded-md bg-[--bg-color-50] border border-[#E1E3E5] flex flex-col space-y-3">
          <p className="font-inter font-bold text-sm text-[#535860]">
            <span
              className={`fas fa-asterisk text-sm ${
                formik.values.is_mandatory ? "text-[#2F80ED]" : "text-[#535860]"
              }  pr-1`}
              aria-hidden="true"
            ></span>{" "}
            Mandatory To Do
          </p>
          <p className="font-inter font-normal text-[13px] text-[#535860]">
            This option makes the to do mandatory. All to dos following will be
            locked until this to do is completed.
          </p>
          <div className="w-full flex flex-row items-center space-x-2 ">
            <div className="form-switch">
              <input
                type="checkbox"
                checked={formik.values.is_mandatory}
                onChange={(e) => {
                  e.stopPropagation();
                  formik.setFieldValue("is_mandatory", e.target.checked);
                }}
                id={"modal_checkbox"}
                className="sr-only"
              />
              <label htmlFor="modal_checkbox" className="bg-slate-400">
                <span className="bg-white shadow-sm" aria-hidden="true"></span>
              </label>
            </div>
            <p className="font-inter font-normal text-[13px] text-[#AEAEAE] capitalize">
              Mandatory
            </p>
          </div>
        </div>
        <div className="p-3 rounded-md bg-[--bg-color-50] border border-[#E1E3E5] flex flex-col space-y-3">
          <p className="font-inter font-bold text-sm text-[#535860]">
            Assignee
          </p>
          <p className="font-inter font-normal text-[13px] text-[#535860]">
            The team or user responsible to complete this to do.
          </p>
            <Menu
              menuButton={
                <div
                  className={`w-full flex flex-row items-center space-x-3 ${
                    isMasterTodo || !formik.values.activity_id
                      ? "cursor-not-allowed"
                      : "cursor-pointer"
                  }`}
                  onClick={(e) => {
                    if(isMasterTodo || !formik.values.activity_id){
                      e.preventDefault();
                      return;
                    }
                  }}
                >
                  <div>
                    <div className="w-[30px] h-[30px] rounded-full bg-[#D9D9D9] flex justify-center items-center">
                      <p className="font-inter font-medium text-[10px] text-[#475569]">
                        {getInitials(formik.values)}

                        {/* {formik.values.user_id
                          ? formik.values.user_id?.label
                              ?.match(/\b\w/g)
                              .join("")
                              .toUpperCase()
                          : formik.values.collaborator_id
                          ? formik.values.collaborator_id?.label
                              ?.match(/\b\w/g)
                              .join("")
                              .toUpperCase()
                          : "Select User".match(/\b\w/g).join("").toUpperCase()} */}
                      </p>
                    </div>
                  </div>
                  {formik.values.collaborator_id ? (
                    <div className="flex flex-col justify-start">
                      <p className="font-inter font-medium text-[13px] text-[#1E293B] line-clamp-1">
                        {formik.values.collaborator_id
                          && formik.values.collaborator_id.label }
                      </p>
                      <p className="font-inter font-medium text-[13px] text-[--bg-color-500] capitalize line-clamp-1">
                        {formik.values.collaborator_id
                          && formik.values.collaborator_id.type }
                      </p>
                    </div>
                  ) : (
                    <div className="flex flex-col justify-start">
                      <p className="font-inter font-medium text-[13px] text-[#1E293B] line-clamp-1">
                        {formik.values.user_id
                          ? formik.values.user_id.label
                          : formik.values.department_id ? "" : "Select User"}
                      </p>
                      <p className="font-inter font-normal text-[12px] text-[--bg-color-500] line-clamp-1">
                        {formik.values.department_id
                          ? formik.values.department_id.label
                          : "Select Department"}
                      </p>
                    </div>
                  )}
                </div>
              }
              overflow="auto"
              direction={"bottom"}
              menuClassName={`h-[300px] !top-[120px] overflow-y-auto scrollbar scrollbar-w-1 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100 ${isMasterTodo || !formik.values.activity_id ? "hidden" : ""}`}
            >
              {!isMasterTodo && formik.values.activity_id && (
                <>
                  <MenuHeader
                    className={`font-inter font-medium text-xs text-[#AFAFAF]`}
                  >
                    Externals
                  </MenuHeader>
                  {["customer", "collaborator"].map((item) => {
                    const values =
                      Object.keys(deptWithUser).length > 0 &&
                      deptWithUser?.collaborators?.filter(
                        (ele) => ele.type === item
                      );
                    return (
                      <>
                        {values?.length > 0 && (
                          <SubMenu
                            label={`${item}s`}
                            className={
                              "font-inter font-normal text-xs text-[#1E293B] capitalize"
                            }
                            menuClassName={`max-h-[300px] overflow-y-auto scrollbar scrollbar-w-1 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100`}
                          >
                            {values?.map((element) => (
                              <MenuItem
                                value={element}
                                className={
                                  "font-inter font-normal text-xs text-[#1E293B] capitalize"
                                }
                                onClick={(e) => {
                                  formik.setFieldValue(
                                    "collaborator_id",
                                    e.value
                                  );
                                  formik.setFieldValue("department_id", "");
                                  formik.setFieldValue("user_id", "");
                                }}
                              >
                                {element.label}
                              </MenuItem>
                            ))}
                          </SubMenu>
                        )}
                      </>
                    );
                  })}
                  <MenuHeader
                    className={`font-inter font-medium text-xs text-[#AFAFAF]`}
                  >
                    Internal Teams
                  </MenuHeader>
                  {Object.keys(deptWithUser).length > 0 &&
                    deptWithUser?.departments?.map((item) =>
                      item.user_departments?.length > 0 ? (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            formik.setFieldValue("department_id", {
                              label: item.label,
                              value: item.value,
                            });
                            formik.setFieldValue("collaborator_id", "");
                            formik.setFieldValue("user_id", "");
                          }}
                        >
                          <SubMenu
                            label={item.label}
                            className={
                              "font-inter font-normal text-xs text-[#1E293B] capitalize"
                            }
                            menuClassName={`max-h-[300px] overflow-y-auto scrollbar scrollbar-w-1 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100`}
                          >
                            {item.user_departments?.map((user) => (
                              <MenuItem
                                className={
                                  "font-inter font-normal text-xs text-[#1E293B] capitalize"
                                }
                                value={user}
                                onClick={(e) => {
                                  e.syntheticEvent.stopPropagation();
                                  formik.setFieldValue("user_id", e.value);
                                  formik.setFieldValue("department_id", {
                                    label: item.label,
                                    value: item.value,
                                  });
                                  formik.setFieldValue("collaborator_id", "");
                                }}
                              >
                                {user.label}
                              </MenuItem>
                            ))}
                          </SubMenu>
                        </div>
                      ) : (
                        <MenuItem
                          className={
                            "font-inter font-normal text-xs text-[#1E293B] capitalize"
                          }
                          value={item}
                          onClick={(e) => {
                            formik.setFieldValue("department_id", {
                              label: item.label,
                              value: item.value,
                            });
                            formik.setFieldValue("collaborator_id", "");
                            formik.setFieldValue("user_id", "");
                          }}
                        >
                          {item.label}
                        </MenuItem>
                      )
                    )}
                </>
              )}
            </Menu>
        </div>
      </div>
      {/* Second Row */}
      <div className="p-3 rounded-md bg-[--bg-color-50] border border-[#E1E3E5] flex flex-col space-y-3">
        <p className="font-inter font-bold text-sm text-[#535860]">
          <span className={`fas fa-link text-sm pr-1 ${formik.values.link_activity && "!text-[--bg-color-500]"}`} aria-hidden="true"></span>{" "}
          Link To Do
        </p>
        <p className="font-inter font-normal text-[13px] text-[#535860]">
          Linking to dos will alter the end time of the to do based end time or
          completed date of a former to do.
        </p>
        <div className="w-full flex flex-row items-center space-x-3">
          <div className="w-full space-y-1">
            <p className="font-inter font-medium text-[13px] text-[#535860]">
              Link To Do
            </p>
            <Select
              // options={workflowFormik.values.workflow_todos
              //   ?.slice(0, activeTodo)
              //   .map((item) => item.activity_id)}
              options={linkAndLoopTodosList}
              isClearable={true}
              menuPortalTarget={document.body}
              className="basic-single text-sm unresetText"
              classNames={{
                control: (style) => {
                  return `!border !shadow-sm ${
                    style.isFocused
                      ? "!border-[--bg-color-300]/50"
                      : "!border-slate-200 hover:!border-gray-300"
                  }`;
                },
                container: (style) => {
                  return "!h-[37.5px] !font-inter !text-sm";
                },
                menuList: (style) => {
                  return `!max-h-[200px]`;
                },
              }}
              name="resposible_team"
              value={formik.values.link_activity}
              onChange={(todo) => {
                formik.setFieldValue("link_activity", todo);
                if (todo?.value){
                  filterLinkComponents(todo.value)
                  formik.setFieldValue("activity_customfields_id", {label: "Performance Date", value: "Performance Date"});
                }else{
                  formik.setFieldValue("activity_customfields_id", "");
                  formik.setFieldValue("duration", 0);
                  setLinkComponentList([])
                };
              }}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                placeholder: (provided, state) => ({
                  ...provided,
                  color: "#9B9B9B",
                  fontSize: "14px",
                }),
              }}
              placeholder="Select Todo"
              menuPlacement="auto"
              isDisabled={linkAndLoopTodosList?.length === 0}
            />
          </div>
          <div className="w-full space-y-1">
            <p className="font-inter font-medium text-[13px] text-[#535860]">
              Reference Date
            </p>
            <Select
              options={formik.values.link_activity ? [{label: "Performance Date", value: "Performance Date"}, ...linkComponentList] : []}
              isClearable={true}
              menuPortalTarget={document.body}
              className="basic-single text-sm unresetText"
              classNames={{
                control: (style) => {
                  return `!border !shadow-sm ${
                    style.isFocused
                      ? "!border-[--bg-color-300]/50"
                      : "!border-slate-200 hover:!border-gray-300"
                  }`;
                },
                container: (style) => {
                  return "!h-[37.5px] !font-inter !text-sm";
                },
                menuList: (style) => {
                  return `!max-h-[200px]`;
                },
              }}
              name="activity_customfields_id"
              value={formik.values.activity_customfields_id}
              onChange={(custom) => {
                formik.setFieldValue("activity_customfields_id", custom);
              }}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                placeholder: (provided, state) => ({
                  ...provided,
                  color: "#9B9B9B",
                  fontSize: "14px",
                }),
              }}
              placeholder="Select Todo"
              menuPlacement="auto"
              isDisabled={linkAndLoopTodosList?.length === 0}
            />
          </div>
          <div className="w-full space-y-1">
            <p className="font-inter font-medium text-[13px] text-[#535860]">
              Duration
            </p>
            <InputField
              type="text"
              wrapperClass="w-full"
              placeholder="Duration"
              name="duration"
              value={formik.values.duration}
              onChange={(e) => {
                if (e.target.value && /^\d*$/.test(e.target.value)) {
                  const value = sanitizeInput(e.target.value);
                  formik.setFieldValue("duration", parseInt(value));
                }else if(e.target.value === ""){
                  formik.setFieldValue("duration", 0);
                }
              }}
              disabled={linkAndLoopTodosList?.length === 0}
              suffix={
                <Listbox
                  value={formik.values.duration_type}
                  onChange={(e) => formik.setFieldValue("duration_type", e)}
                  disabled={linkAndLoopTodosList?.length === 0}
                >
                  <div className="relative">
                    <Listbox.Button className={`flex items-center p-1 ${ linkAndLoopTodosList?.length === 0 ? "bg-slate-100" : "bg-white"} border-none`}>
                      <p className="font-inter font-medium text-[13px] text-[#535860]">
                        {formik.values.duration_type}
                      </p>
                      <i class="fa-regular fa-chevron-down ml-1 text-[12px] text-[#737373]"></i>
                    </Listbox.Button>
                    <Listbox.Options className="absolute right-0 mt-1 bg-white border rounded-md shadow-md w-24">
                      {["hours", "days"].map((unit, index) => (
                        <Listbox.Option
                          key={index}
                          value={unit}
                          className="px-3 py-2 hover:bg-gray-200 cursor-pointer"
                        >
                          {unit}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </div>
                </Listbox>
              }
            />
          </div>
        </div>
      </div>

      {/* Third Row */}
      <div className="p-3 rounded-md bg-[--bg-color-50] border border-[#E1E3E5] flex flex-col space-y-3">
        <p className="font-inter font-bold text-sm text-[#535860]">
          <span
            className={`fa-regular fa-link-simple text-sm pr-1 ${formik.values.dependent_todo && formik.values.dependent_todo_custom_field_id && formik.values.dependent_todo_custom_field_value && "!text-[--bg-color-500]"}`}
            aria-hidden="true"
          ></span>{" "}
          Dependent To Do
        </p>
        <p className="font-inter font-normal text-[13px] text-[#535860]">
          The activation of this to do will be dependent on the completion of
          another to do.
        </p>
        <div className="w-full flex flex-row items-center space-x-3">
          <div className="w-full space-y-1">
            <p className="font-inter font-medium text-[13px] text-[#535860]">
              Dependent To Do
            </p>
            <Select
              options={dependentTodoList}
              isClearable={true}
              menuPortalTarget={document.body}
              className="basic-single text-sm unresetText"
              classNames={{
                control: (style) => {
                  return `!border !shadow-sm ${
                    style.isFocused
                      ? "!border-[--bg-color-300]/50"
                      : "!border-slate-200 hover:!border-gray-300"
                  }`;
                },
                container: (style) => {
                  return "!h-[37.5px] !font-inter !text-sm";
                },
                menuList: (style) => {
                  return `!max-h-[200px]`;
                },
              }}
              name="dependent_todo"
              value={formik.values.dependent_todo}
              onChange={(todo) => {
                formik.setFieldValue("dependent_todo", todo);
                if (todo) filterDependentTodoCompnents(todo.value);
                formik.setFieldValue("dependent_todo_custom_field_id", "");
                formik.setFieldValue("dependent_todo_custom_field_value", "");
              }}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                placeholder: (provided, state) => ({
                  ...provided,
                  color: "#9B9B9B",
                  fontSize: "14px",
                }),
              }}
              placeholder="Select Todo"
              menuPlacement="auto"
              isDisabled={dependentTodoList?.length === 0}
            />
          </div>
          <div className="w-full space-y-1">
            <p className="font-inter font-medium text-[13px] text-[#535860]">
              Component
            </p>
            <Select
              options={dependentComponentList}
              isClearable={true}
              menuPortalTarget={document.body}
              className="basic-single text-sm unresetText"
              classNames={{
                control: (style) => {
                  return `!border !shadow-sm ${
                    style.isFocused
                      ? "!border-[--bg-color-300]/50"
                      : "!border-slate-200 hover:!border-gray-300"
                  }`;
                },
                container: (style) => {
                  return "!h-[37.5px] !font-inter !text-sm";
                },
                menuList: (style) => {
                  return `!max-h-[200px]`;
                },
              }}
              name="dependent_todo_custom_field_id"
              value={formik.values.dependent_todo_custom_field_id}
              onChange={(custom) => {
                formik.setFieldValue("dependent_todo_custom_field_id", custom);
                if (custom) {
                  let list = dependentComponentWithValues.find(
                    (item) => item.id === custom.value
                  );
                  if (list && ["check box", "toggle"].includes(list?.todo_component?.type)) {
                    setIsMultiSelect(false);
                    list = [
                      {
                        label: "True",
                        value: "true"
                      },
                      {
                        label: "False",
                        value: "false"
                      }
                    ]
                    setDependentValuesList(list);
                  }else if(list){
                    setIsMultiSelect(true);
                    list = JSON.parse(
                      list?.todo_component?.list_values || "[]"
                    );
                    list = list.map((item) => ({ label: item, value: item }));
                    setDependentValuesList(list);
                  }
                  formik.setFieldValue("dependent_todo_custom_field_value", "");
                }
              }}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                placeholder: (provided, state) => ({
                  ...provided,
                  color: "#9B9B9B", // Set your desired color here
                  fontSize: "14px",
                }),
              }}
              placeholder="Select Todo"
              menuPlacement="auto"
              isDisabled={dependentTodoList?.length === 0}
            />
            {/* {Boolean(
                    formik.touched.resposible_team && formik.errors.resposible_team
                    ) ? (
                    <p className="text-xs text-rose-500 text-left">
                        {`${formik.errors.resposible_team}!`}
                    </p>
                    ) : null} */}
          </div>
          <div className="w-full space-y-1">
            <p className="font-inter font-medium text-[13px] text-[#535860]">
              Value for Activation
            </p>
            <Select
              options={dependentValuesList}
              isClearable={true}
              menuPortalTarget={document.body}
              className="basic-single text-sm unresetText"
              classNames={{
                control: (style) => {
                  return `!border !shadow-sm ${
                    style.isFocused
                      ? "!border-[--bg-color-300]/50"
                      : "!border-slate-200 hover:!border-gray-300"
                  }`;
                },
                container: (style) => {
                  return "!h-[37.5px] !font-inter !text-sm";
                },
                menuList: (style) => {
                  return `!max-h-[200px]`;
                },
              }}
              name="dependent_todo_custom_field_value"
              value={formik.values.dependent_todo_custom_field_value}
              onChange={(custom) => {
                formik.setFieldValue(
                  "dependent_todo_custom_field_value",
                  custom
                );
              }}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                placeholder: (provided, state) => ({
                  ...provided,
                  color: "#9B9B9B",
                  fontSize: "14px",
                }),
              }}
              placeholder="Select Todo"
              menuPlacement="auto"
              isDisabled={dependentTodoList?.length === 0}
              isMulti={isMultiSelect}
              closeMenuOnSelect={!isMultiSelect}
              hideSelectedOptions={!isMultiSelect}
              components={{
                MultiValue,
              }}
            />
          </div>
        </div>
      </div>

      {/* Fourth Row */}
      <div className="p-3 rounded-md bg-[--bg-color-50] border border-[#E1E3E5] flex flex-col space-y-3">
        <p className="font-inter font-bold text-sm text-[#535860]">
          <span
            className={`fas fa-infinity text-sm pr-1 ${formik.values.loop_activity && "!text-[--bg-color-500]"}`}
            aria-hidden="true"
          ></span>{" "}
          Loop To Do
        </p>
        <p className="font-inter font-normal text-[13px] text-[#535860]">
          Looping a to do will complete the to do automatically based on the
          completion of a following to do.
        </p>
        <div className="w-full flex flex-row items-center space-x-3">
          <div className="w-1/3 space-y-1">
            <p className="font-inter font-medium text-[13px] text-[#535860]">
              Loop To Do
            </p>
            <Select
              // options={workflowFormik.values.workflow_todos
              //   ?.slice(0, activeTodo)
              //   .map((item) => item.activity_id)}
              options={linkAndLoopTodosList}
              isClearable={true}
              menuPortalTarget={document.body}
              className="basic-single text-sm unresetText"
              classNames={{
                control: (style) => {
                  return `!border !shadow-sm ${
                    style.isFocused
                      ? "!border-[--bg-color-300]/50"
                      : "!border-slate-200 hover:!border-gray-300"
                  }`;
                },
                container: (style) => {
                  return "!h-[37.5px] !font-inter !text-sm";
                },
                menuList: (style) => {
                  return `!max-h-[200px]`;
                },
              }}
              name="loop_activity"
              value={formik.values.loop_activity}
              onChange={(todo) => {
                formik.setFieldValue("loop_activity", todo);
              }}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                placeholder: (provided, state) => ({
                  ...provided,
                  color: "#9B9B9B",
                  fontSize: "14px",
                }),
              }}
              placeholder="Select Todo"
              menuPlacement="top"
              isDisabled={linkAndLoopTodosList?.length === 0}
            />
          </div>
        </div>
      </div>

      <div className="relative bottom-0 p-3 rounded-md bg-[--bg-color-50] border border-[#E1E3E5] flex flex-col space-y-3">
        <div className="flex flex-row items-center justify-between">
          <p
            className="font-inter font-semibold text-[13px] text-[#EB5757] cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              setActiveModal(false);
              workflowFormik.setFieldValue(
                "workflow_todos",
                workflowFormik.values.workflow_todos.filter(
                  (item) => item.activity_id.value !== data?.activity_id?.value
                )
              );
              formik.resetForm();
            }}
          >
            Remove To Do
          </p>
          <button
            className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 cursor-pointer"
            type="submit"
            onClick={(e) => {
              e.stopPropagation();
              formik.handleSubmit();
            }}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default TodoConfig;
